module.exports = __webpack_public_path__ + "img/user.b88aa9e7.svg";